import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import dimensions from 'dimensions'
import Utils from 'utils'
import CustomFilter from '../DashboardItem/options/CustomFilters/CustomFilter'

const getDefaultFilter = () => ({
  dimension: 'region',
  operator: 'equals',
  values: [],
  id: uuidv4(),
})

const CustomFilters = ({
  item,
  type,
  updatedCustomFilters,
  setUpdatedCustomFilters,
}) => {
  const getFilterDimensions = () => {
    const ttype = type || Utils.Cube.getType(item)
    return dimensions.filter((dim) => !dim.intendedFor || dim.intendedFor === ttype)
  }

  const handleAdd = () => {
    setUpdatedCustomFilters([...updatedCustomFilters, getDefaultFilter()])
  }

  const handleRemove = (filter) => {
    const newFilters = updatedCustomFilters.filter((f) => f.id !== filter.id)
    setUpdatedCustomFilters(newFilters)
  }
  const handleUpdate = (filter, attrs) => {
    const newFilters = updatedCustomFilters.map((f) => (f.id === filter.id ? { ...filter, ...attrs } : f))
    setUpdatedCustomFilters(newFilters)
  }

  const ttype = type || Utils.Cube.getType(item)

  return (
    <div>
      <div>Custom Filters</div>
      {updatedCustomFilters.map((filter, index) => (
        <CustomFilter
          key={index}
          index={index}
          size={updatedCustomFilters.length}
          filter={filter}
          type={ttype}
          onAdd={handleAdd}
          onRemove={handleRemove}
          onUpdate={handleUpdate}
          dimensions={getFilterDimensions()}
        />
      ))}
    </div>
  )
}

export default CustomFilters
